import { Component } from '@angular/core';
import {MenuComponent} from "./menu/menu.component";
import {HeaderComponent} from "./header/header.component";

@Component({
  selector: 'app-template',
  standalone: true,
  imports: [
    MenuComponent,
    HeaderComponent
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss'
})
export class TemplateComponent {
  menuOpened = true;

}
